import { AmplifyProvider } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import "animate.css";
import { Amplify, Auth } from "aws-amplify";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "@/styles/index.scss";

import App from "./App";
import awsConfig from "./aws-exports";
import { ConfirmDialogProvider } from "./baseComponents/ConfirmDialogContext";
import AutoScrollToTop from "./components/AutoScrollTop";
import { domainName } from "./constants/config";
import "./instrument";

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);
// Assuming you have two redirect URIs, and the first is for localhost and second is for production
const [localRedirectSignIn, productionRedirectSignIn] = [
  "http://localhost:5173/",
  "https://www." + domainName + ".com/",
];

const [localRedirectSignOut, productionRedirectSignOut] = [
  "http://localhost:5173/",
  "https://www." + domainName + ".com/",
];

// console.log("isLocalhost:", isLocalhost);
// console.log("localRedirectSignIn:", isLocalhost ? localRedirectSignIn : productionRedirectSignIn);
// console.log("localRedirectSignOut:", isLocalhost ? localRedirectSignOut : productionRedirectSignOut);

const updatedAwsConfig = {
  ...awsConfig,
  oauth: {
    ...awsConfig.oauth,
    redirectSignIn: isLocalhost ? localRedirectSignIn : productionRedirectSignIn,
    redirectSignOut: isLocalhost ? localRedirectSignOut : productionRedirectSignOut,
  },
};

Amplify.configure(updatedAwsConfig);
Auth.configure(updatedAwsConfig);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <AmplifyProvider>
    <ConfirmDialogProvider>
      <BrowserRouter>
        <AutoScrollToTop />
        <App />
      </BrowserRouter>
    </ConfirmDialogProvider>
  </AmplifyProvider>
);
